/** @jsx isolateComponent */

import type { ReactNode } from 'react';

import { Animation, Colors, Typography } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * The error message to render.
   */
  children: ReactNode;
};

const Styles = labelStyles('InAppSidebarError', {
  toggle: {
    ...Typography.smallPrint1,
    color: Colors.error,
    cursor: 'pointer',
    padding: '3px 0',
    borderBottom: `1px solid transparent`,
    transition: Animation.transitionValue,
    '&:hover, &:focus': {
      borderBottomColor: Colors.error,
    },
  },
  message: {
    color: Colors.error,
    marginTop: 10,
    padding: 10,
    border: `1px solid ${Colors.gray20}`,
    borderRadius: 5,
    font: '14px/18px monospace',
  },
});

/**
 * Simple error message to render if, for instance, data
 * fails to load. Should ideally never be seen by users.
 */
const InAppSidebarError = (props: Props) => {
  return (
    <details>
      <summary css={Styles.toggle}>Oh no, something went wrong!</summary>
      <pre css={Styles.message}>{props.children}</pre>
    </details>
  );
};

export default InAppSidebarError;
